export default {
  created () {
    this._loadQueryParams().then(() => {
      this._createWatcher()
    })
  },
  watch: {
    '$route' (toRoute, fromRoute) {
      this._loadQueryParams()
    }
  },
  computed: {
    queryParams: () => this.$store.getters.queryParams
  },
  methods: {
    _pushQueryParams () {
      let query = { ...this.$store.state.queryStringHelper.queryParams }
      query.ssn = '' //Sensitive info should not be displayed in the query param string
      query.dob = ''
      this.$router.push({ query }, null, (e) => {
        // stops annoying Redundant Navigation errors
        if(e.name !== 'NavigationDuplicated') {
          throw e;
        }
      });
    },
    _loadQueryParams() {
      let defaultQueryParams = this.defaultQueryParams ? this.defaultQueryParams : {}
      return this.$store.dispatch('LOAD_QUERY_PARAMS', { ...defaultQueryParams, ...this.$route.query })
    },
    _createWatcher () {
      this.$store.subscribe((mutation, state) => {
        if (mutation && mutation.payload && mutation.payload.path) {
          let path = mutation.payload.path
          if ((this.eagerQueryParams !== false) && path && path.indexOf('queryParams') >= 0) {
            this._pushQueryParams()
          }
        }
      })
    }
  }
}
